module.exports = __webpack_public_path__ + "static/media/icon_storage_old.b588e742.svg";